/**
 * Jelp Shopify Theme
 * Made with love and coffee, lots of it.
 */

// Input Bindings
var currentCollection = document.getElementById('collectionValidation').value
var items = document.getElementById('total_items').value
var checkout = document.getElementById('checkoutButton')
var price = document.getElementById('totalPriceText')
var unit = document.getElementById('totalPriceMoney')
var address = document.getElementById('getAddress')
var validated = document.getElementById('addressValid')
var view = document.getElementById('map')
var parsedCollection = parseInt(currentCollection)

// Map Objects
var map
var marker
var geocoder
var coverage

// Information and Value Variables
var current
var webpage
var coords
var city

function getCollectionImage(id) {
    return collectionData.images
}

function verifyPolygon(id) {
    return collectionData.polygon.data
}

function waitToInit() {
//   	checkout.disabled = true
    if (parseInt(items) == 0) {
        return false
    } else {
        
      if (getCookie('app')) {
//         	checkout.disabled = false
            document.getElementById('mapContainer').style.display = 'none';
        }

        checkCartItems()
        
        google.maps.event.addDomListener(window, 'load', initMap);
    }
}

function initMap() {
    map = new google.maps.Map(document.getElementById('map'), {
        center: {
            'lat': 32.513730,
            'lng': -116.995348
        },
        zoom: 12
    })

    coverage = new google.maps.Polygon({
        path: verifyPolygon(currentCollection),
        map: map,
        strokeColor: '#2ECC71',
        strokeOpacity: 0.55,
        strokeWeight: 2,
        fillColor: '#2ECC71',
        fillOpacity: 0.3
    })

    getUserLocation()

    marker = new google.maps.Marker({
        map: map,
        animation: google.maps.Animation.DROP,
        position: coords,
        draggable: true
    })

    geocoder = new google.maps.Geocoder;
    google.maps.event.addDomListener(marker, 'dragend', onDragEnd)
}

function onDragEnd(position) {
    var obj = {
      coords: {
        'latitude': position.latLng.lat(),
        'longitude': position.latLng.lng()
      }
    }

	setUserPosition(obj)
}

function getUserLocation() {
  	if (getCookie('app') || getUrlQueries()["ref"] == "jelpapp") {
        return true
    } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(setUserPosition)
        } else {
          disableCart('No pudimos obtener tu ubicación.')
          return false
        }
    }
}

function setUserPosition(position) {
    if (document.getElementById('clientCoords').value != '') {
        coords = parseMobileLocation(document.getElementById('clientCoords').value)
    } else {
        coords = {
            'lat': position.coords.latitude,
            'lng': position.coords.longitude
        }
    }

    map.setCenter(coords)
    marker.setPosition(coords)

    geocodePosition(parseCoords(marker.getPosition().lat(), marker.getPosition().lng()))

    setTimeout(function() {
        if (!google.maps.geometry.poly.containsLocation(marker.getPosition(), coverage)) {
          	validated.innerText = 'Estás fuera del área de servicio.'
            validated.style.background = '#F35432'
            validated.style.color = '#FFF'
            validated.style.borderColor = 'transparent'
            
            disableCart('Estás fuera del área de servicio.')
            return false
        } else {
        	validated.innerText = '¡Estás dentro del área de servicio!'
            validated.style.background = '#FFF'
            validated.style.borderColor = '#E8E9EB'
            validated.style.color = 'inherit'
            
            checkout.value = 'Finalizar pedido - ' + unit.value
            checkout.disabled = false
            
            checkCartItems()
        }
    }, 420)
}

function geocodePosition(position) {
    geocoder.geocode({ 'location': position }, function (res, status) {
        if (status === 'OK') {
            if (res[0]) {
                // SET FORMATTED ADDRESS
                document.getElementById('getAddress').innerText = res[0].formatted_address;
            }
        } else {
          	address.innerText = 'No pudimos obtener tu dirección.'
        	disableCart('No pudimos obtener tu dirección.')
        }
    })
}

function parseCoords(lat, lng) {
    coords = {
        'lat': parseFloat(lat),
        'lng': parseFloat(lng)
    }
    return coords;
}

function parseMobileLocation(str) {
    var string = str
    var arr = string.split(',')
    return {
        lat: parseFloat(arr[0]),
        lng: parseFloat(arr[1])
    }
}

function verifySchedule(server) {
    var today = new Date().getDay()
    var todayDate = server
    var openHour = new Date()
    var closeHour = new Date()
    var time = collectionData.schedule

    if (time) {
        for (var i = 0; i < time.length; i++) {
            if (today == i) {
                if (time[i].start != null && time[i].end != null) {
                    var open = time[i].start
                    var close = time[i].end

                    var openMin = open.split(/[/: ]/)
                    var closeMin = close.split(/[/: ]/)

                    var parsedOpen = parseInt(open.split(/[/ :]/))
                    var parsedClose = parseInt(close.split(/[/ :]/)) || 0
                    var parsedOpenMin = parseInt(openMin[1]) || 0
                    var parsedCloseMin = parseInt(closeMin[1])

                    openHour.setHours(parsedOpen, parsedOpenMin, 0)
                    closeHour.setHours(parsedClose, parsedCloseMin, 0)

                    unixOpen = Date.parse(openHour) / 1000
                    unixClose = Date.parse(closeHour) / 1000
                    unixToday = Date.parse(todayDate) / 1000

                    if (unixToday >= unixOpen) {
                        if (unixToday < unixClose) {
                            return true
                        } else {
                            disableCart('Empresa fuera del horario de servicio.')
                            return false
                        }
                    } else {
                        disableCart('Empresa fuera del horario de servicio.')
                        return false
                    }
                } else {
                    disableCart('Empresa fuera del horario de servicio.')
                    return false
                }
            }
        }
    }
    disableCart('Empresa fuera del horario de servicio.')
}

function disableCart(str) {
    checkout.value = str
    checkout.disabled = true
}

function toggleMap () {
	view.classList.toggle('show-map')
    
    google.maps.event.trigger(map, 'resize')

}

function checkCartItems() {
    var info = document.getElementById('collection2')
    var arr = []

    if (parseInt(price.value) < 10000) {
        disableCart('Mínimo de compra es $100.00')
        return false
    }

    if (info != null) {
      for (i = 0; i < parseInt(items); i++) {
        var index = i + 1
        var item = document.getElementById('collection' + index)

        if (item == null) {
            return true
        } else {
          arr.push({id: parseInt(item.value)})
        }
      }
      
      for (k = 0; k < arr.length; k++) {
        var leng = arr.length - 1

        if (parseInt(arr[k].id) != parsedCollection) {
          disableCart('Selecciona productos de la misma empresa.')
          return false
        }

        if (k == leng) {
          getHeaders()
          return true
        }
      }
    } else {
    	getHeaders()
    }

}

function getUrlQueries() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function setHeaders() {
	var header = this.getResponseHeader("date")
    var time = new Date()
    var offset = time.getTimezoneOffset()
   	var client = new Date(header)
    
    verifySchedule(client)
}

function getHeaders() {
  	var ajax = new XMLHttpRequest()
    
    ajax.open("HEAD", document.location)
    ajax.onload = setHeaders
    ajax.send()
}

function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length == 2)
        return parts.pop().split(';').shift();
}

function setAppCookie() {
    document.cookie = 'app=jelp_app;secure;expires=January 19, 2038 03:14:07 GMT'
}

